import React from "react";
import { Navigate, useParams } from "react-router-dom";
import ServiceLanding from "@/components/services/ServiceLanding";
import { getServiceById } from "@/data/services";

export default function ServiceDetail() {
  const { serviceId } = useParams();
  const service = getServiceById(serviceId);

  if (!service) {
    return <Navigate to="/services" replace />;
  }

  return <ServiceLanding service={service} />;
}
